import { Box, IconButton, Typography, Popover } from '@mui/material';
import { MixpanelTracking } from '@/services/mixpanel';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';

import { MixpanelEventHub } from '@/services/eventEnums';
import { useTranslation } from 'react-i18next';
import React from 'react';

export default function SaveAreaPopover({
  anchorEl,
  setAnchorEl,
  setIsActive,
  open,
  id,
  user,
  getPopOverContent,
}: {
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: (anchorEl: HTMLButtonElement | null) => void;
  setIsActive: (isActive: boolean) => void;
  open: boolean;
  id: string | undefined;
  user: any;
  getPopOverContent: (user: any) => React.ReactNode | undefined;
}) {
  const { t } = useTranslation('orderImagery');
  const handleClose = () => {
    setAnchorEl(null);
    setIsActive(false);
  };

  return (
    <Popover
      className="saved-area-popover"
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Box>
        <Box className="popover-header">
          <Typography variant="h6">{t('mySavedAreas')}</Typography>
          <IconButton
            onClick={() => {
              MixpanelTracking.getInstance().track(
                MixpanelEventHub.HUB_MY_SAVED_AREAS_SAVED_AOI_S_X
              );
              handleClose();
            }}
          >
            <ClearOutlinedIcon />
          </IconButton>
        </Box>
        {getPopOverContent(user)}
      </Box>
    </Popover>
  );
}
